var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-group"},[_c('v-select',{attrs:{"multiple":true,"label":"name","options":_vm.options,"filterable":false},on:{"search":_vm.onSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }